export const announcementSliderOption = {
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: false,
	infinite: true,
	vertical: false,
	verticalSwiping: false,
	fade: true,
	speed: 300,
	cssEase: 'ease-in-out',
	variableWidth: false,
	autoplay: true,
	autoplaySpeed: 2500,
	arrows: false,
};
